export function getSaleClass(sale, otherSaleExist=false) {
    let saleClass = [];
    if (sale.submitted !== null && sale.submitted !== '') {
        saleClass.push('submitted');
    } else {
        saleClass.push('unsubmitted');
    }
    const note = (sale.Note || '').toLowerCase();

    if (sale.ebayprice == 0 ) {
        saleClass.push('zero-price');
    } else if (sale.CancellationRequested) {
        saleClass.push(' cancel-requested');
    } else if (sale.submitted && sale.Vendor == 'eBay' && !sale.vendorLink) {
        saleClass.push('ebay-guest');
    } else if (
        note.includes('requested to cancel') ||
        note.includes('return requested')
        ) {
        saleClass.push('canceled');
    } else if (sale.international) {
        saleClass.push('internationl');
    } else if (sale.shippingstreet1.startsWith('Reference #')){// || $sale->country != 'US' || ($sale->country == 'US' && ($sale->state == 'HA' || $sale->state == 'AK' || $sale->state == 'PR' || $sale->state == 'GU' || $sale->state == 'VI' || $sale->state == 'AE' || $sale->state == 'AA' || $sale->state == 'AP' || $sale->state == 'AS' || $sale->state == 'DC' || $sale->state == 'FM' || $sale->state == 'MH' || $sale->state == 'MP' || $sale->state == 'PW'))) {
        saleClass.push('global');
    } else if (sale.taxed) {
        saleClass.push('tax');
    } else if (otherSaleExist) {
        saleClass.push('another-sale-exist');
    }
    return saleClass;
}